import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ApiClientData } from '../home-types';
import { HomeService } from '../home.service';
import { Preloads } from '../../common/component-interfaces';
import { TabsetComponent, ToastService } from 'ng-uikit-pro-standard';
import { Observable, Subject } from 'rxjs';
import { ClipboardService } from 'ngx-clipboard';
import { SimpleModalComponent } from '../../common/modal/simple-modal/simple-modal.component';

@Component({
  selector: 'app-developer',
  templateUrl: './developer.component.html',
  styleUrls: ['./developer.component.scss']
})
export class DeveloperComponent implements OnInit, Preloads {

  @ViewChild('clientInfoModal') clientInfoModal: SimpleModalComponent;  
  @Input() showHeader: boolean = true;
  isLoaded: boolean = false;
  isLoading?: boolean = false;
  $allVisible: Subject<boolean> = new Subject<boolean>();

  apps: ApiClientData[];
  blankApp: ApiClientData = null;

  newApp: ApiClientData = null;
  isListingActive: boolean = true;
  constructor(private homeService: HomeService, public clipboardService: ClipboardService, public toast: ToastService) { }

  hasLoaded(): boolean {
    return this.isLoaded;
  }

  ngOnInit() {
    this.homeService.getApiApps().subscribe(
      apps => {
        this.apps = apps || [];
        this.isLoaded = true;
      },
      () => {
        this.apps = [];
        this.isLoaded = true;
        this.toast.error('Unable to load API applications.', 'Error', {positionClass: 'md-toast-bottom-right', toastClass: 'opaque'});
      }
    );
  }
  toggleTab(isListing: boolean) {
    this.isListingActive = isListing;

    if (!isListing) {
      // Reset the new app form when switching to the new client tab
      this.newApp = this.isListingActive ? {} as ApiClientData : null; // Reset newApp when hiding the form
    }
  }
  onCreate(apiClientData: ApiClientData) {
    this.$allVisible.next(false);    
    this.isListingActive = true;
    apiClientData._startOpen = true;
    this.newApp = apiClientData;
    
    this.apps.push(apiClientData);

    this.clientInfoModal.visible = true
  }

  onDelete(apiClientData: ApiClientData) {
    this.apps = this.apps.filter(app => app.client_id != apiClientData.client_id);
  }

  get sortedApps() {
    return this.apps.sort((a, b) => a.applicationName.localeCompare(b.applicationName));
  }

  copyClientId() {
    this.clipboardService.copyFromContent(this.newApp.client_id);
    this.toast.success('Copied to clipboard', 'Success', {positionClass: 'md-toast-bottom-right', toastClass: 'opaque'});
  }

  copyClientSecret() {
    this.clipboardService.copyFromContent(this.newApp.client_secret);
    this.toast.success('Copied to clipboard', 'Success', {positionClass: 'md-toast-bottom-right', toastClass: 'opaque'});
  }

}
